import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-agreement',
  templateUrl: './agreement.component.html',
  styleUrls: ['./agreement.component.css']
})
export class AgreementComponent implements OnInit {
  scroll = 0;
  percent = 0;
  @ViewChild('secretscroll', { read: ElementRef }) public panel: ElementRef;
  constructor(public dialogRef: MatDialogRef<AgreementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data.type == 'secret') {
      this.percent = 12.5;
    } else {
      this.percent = 5.88235294;
    }
  }

  ngOnInit() {
  }

  scrollWin() {
    if (this.data.type == 'secret') {
      this.scroll = this.scroll + 200;
      this.percent = this.percent + 12.5;
      if (this.scroll >= 1600) {
        this.scroll = 0;
        this.percent = 12.5;
      }
    } else {
      this.scroll = this.scroll + 400;
      this.percent = this.percent + 5.88235294;
      if (this.scroll >= 6800) {
        this.scroll = 0;
        this.percent = 5.88235294;
      }
    }

    this.panel.nativeElement.scrollTo(0, this.scroll);
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/agreement/agreement.component.ts